import Modal from "../../../components/Modal/Modal";

const ShareModal = ({ open, close, preview, projectName, version }) => (
  <Modal open={open} close={close}>
    <h2>Sürüm Önizlemesi</h2>
    <textarea className="modal-preview" rows={20} value={preview} readOnly />
    <div className="modal-buttons">
      <button
        className="modal-secondary-button"
        onClick={() =>
          navigator.share
            ? navigator.share({
                title: `${projectName} - Önizleme`,
                text: preview,
              })
            : navigator.clipboard.writeText(preview)
        }
      >
        Paylaş
      </button>
      <button
        className="modal-add-button"
        onClick={() => {
          const blob = new Blob([preview], { type: "text/plain" });
          const url = URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = `${projectName}_Buglog_${version}.txt`;
          a.click();
          URL.revokeObjectURL(url);
        }}
      >
        İndir
      </button>
      <button className="modal-close-button" onClick={close}>
        Kapat
      </button>
    </div>
  </Modal>
);
export default ShareModal;
